import { render, staticRenderFns } from "./JobOfferTag.vue?vue&type=template&id=e49f4430&scoped=true&"
import script from "./JobOfferTag.vue?vue&type=script&lang=js&"
export * from "./JobOfferTag.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferTag.vue?vue&type=style&index=0&id=e49f4430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49f4430",
  null
  
)

export default component.exports